import { gql } from '@/__generated__';

export const GET_DEVICE_CONFIGURATION_FILE_HISTORY_DOWNLOAD_URL = gql(`#graphql
  query GetDeviceConfigurationFileHistoryDownloadUrl($deviceId: ID!, $fileName: String!) {
    deviceConfigurationFileHistoryDownloadUrl(deviceId: $deviceId, fileName: $fileName)
  }
`);
